import { PlatformFee } from 'store/Tenancy/types';

export function userCanViewProposal(platformFee: PlatformFee, userId: number | undefined): boolean {
  if (!userId) return false;

  if (platformFee.approver?.id === userId) return true;

  return (platformFee.viewers || []).some(viewer => viewer.id === userId);
}

export function userCanApproveProposal(platformFee: PlatformFee, userId: number | undefined): boolean {
  if (!userId) return false;

  return platformFee.approver?.id === userId;
}
